import { getFunctions, httpsCallable } from "firebase/functions";
import { parseSquareError } from "./SquareUtils";

// Calls the processScanPayment Firebase Cloud Function
export const processScanPayment = async ({ squareId, type, cardId, amount }) => {
  try {
    // Validate inputs
    if (!squareId || !["scan-down", "scan-final", "extra-imprint"].includes(type)) {
      throw new Error("Invalid squareId or type");
    }

    const functions = getFunctions();
    const processScanPaymentFn = httpsCallable(functions, "processScanPayment");

    // Call the endpoint
    const response = await processScanPaymentFn({ customerId: squareId, type, cardId, amount });
    const data = response.data;

    // Check for success
    if (data.status !== "success") {
      throw new Error("Payment processing failed");
    }

    return {
      
      transactionId: data.transactionId,
      orderId: data.orderId,
      paymentId: data.paymentId,
      amount: data.amount,
      card: data.card
    };
  } catch (error) {
    // Parse Square-specific errors
    const errorMessage = parseSquareError(error);
    throw new Error(`Payment failed: ${errorMessage}`);
  }
};